import React, { FC } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { User } from '../../interfaces/User';
import { Wrapper, HeadlineWrapper, Headline, EditIconWrapper, EditIcon, AdditionalItemDivider, DataWrapper, DataRow as DataRowBase, DataRowHeader, DataRowContent as DataRowContentBase } from './AdditionalListContentUI';
import { formatDate } from '../../utils/DateUtils';

const DataRow = styled(DataRowBase)`
  display: grid;
  grid-template-columns: 1fr 3fr;
`;
const DataRowContent = styled(DataRowContentBase)`
  align-items: flex-start;
`;

export interface AdditionalUserListContentProps {
  item: User;
  editRoute: string;
}
const formatCustomerTypeAsText = (type: string): string => {
  switch (type) {
    case 'HOUSING_INDUSTRY':
      return 'Wohnungswirtschaft';
    case 'MAJOR_CUSTOMERS':
      return 'Großkunden';
    case 'BUSINESS':
      return 'Gewerbekunde'; // Geschäftskunden
    default:
      return '-';
  }
};

export const AdditionalUserListContent: FC<AdditionalUserListContentProps> = (props) => {
  const { item, editRoute } = props;

  return (
    <Wrapper>
      <HeadlineWrapper>
        <Headline>Nutzerdaten</Headline>
        <EditIconWrapper>
          <Link to={editRoute.replace('{id}', item.id)}>
            <EditIcon icon={'edit'} size={20} />
          </Link>
        </EditIconWrapper>
      </HeadlineWrapper>
      <AdditionalItemDivider/>
      <DataWrapper>
        <DataRow>
          <DataRowHeader>Zielgruppe</DataRowHeader>
          <DataRowContent>
          {
            item?.customerTypes?.map((type, index) => {
              return ((index + 1) !== item.customerTypes.length) ? `${formatCustomerTypeAsText(type)}, ` : formatCustomerTypeAsText(type);
            })
          }
          </DataRowContent>
        </DataRow>
        <AdditionalItemDivider/>
        <DataRow>
          <DataRowHeader>Telefon:</DataRowHeader>
          <DataRowContent>{item?.phone}</DataRowContent>
        </DataRow>
        <AdditionalItemDivider/>
        <DataRow>
          <DataRowHeader>E-Mail:</DataRowHeader>
          <DataRowContent>{item?.email}</DataRowContent>
        </DataRow>
      </DataWrapper>
    </Wrapper>
  );
};
